export default "/images/framework/face_3.1a493994.png?1a493994";